import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

export const getExchangeInstance = (seoName) => {
  const baseURL = process.env.REACT_APP_EXCHANGE_URL.replace("*", seoName);

  return axios.create({
    baseURL,
  });
};

export default axiosInstance;
